// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana Process Types
 * Auto-generated input/output schemas for every Rana process tag. Do not edit manually.
 *
 * The version of the OpenAPI document: generated
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { RanaFile } from "./RanaFile";
import {
  RanaFileFromJSON,
  RanaFileFromJSONTyped,
  RanaFileToJSON,
  RanaFileToJSONTyped,
} from "./RanaFile";

/**
 *
 * @export
 * @interface RanaDtacogoV1Output
 */
export interface RanaDtacogoV1Output {
  /**
   *
   */
  file: RanaFile;
  /**
   *
   */
  results: RanaFile;
}

/**
 * Check if a given object implements the RanaDtacogoV1Output interface.
 */
export function instanceOfRanaDtacogoV1Output(value: object): value is RanaDtacogoV1Output {
  if (!("file" in value) || value["file"] === undefined) return false;
  if (!("results" in value) || value["results"] === undefined) return false;
  return true;
}

export function RanaDtacogoV1OutputFromJSON(json: any): RanaDtacogoV1Output {
  return RanaDtacogoV1OutputFromJSONTyped(json, false);
}

export function RanaDtacogoV1OutputFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): RanaDtacogoV1Output {
  if (json == null) {
    return json;
  }
  return {
    file: RanaFileFromJSON(json["file"]),
    results: RanaFileFromJSON(json["results"]),
  };
}

export function RanaDtacogoV1OutputToJSON(json: any): RanaDtacogoV1Output {
  return RanaDtacogoV1OutputToJSONTyped(json, false);
}

export function RanaDtacogoV1OutputToJSONTyped(
  value?: RanaDtacogoV1Output | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    file: RanaFileToJSON(value["file"]),
    results: RanaFileToJSON(value["results"]),
  };
}
